import { createClient } from '@supabase/supabase-js'

// Anon keys are public-by-design (RLS does the actual security work), but URL
// and key are env-configurable so dev/staging/prod can point at separate
// Supabase projects when we need to. Fallbacks keep existing environments
// working if envs aren't set — remove once all environments configure them.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://ernsdcoqdwwutczluuue.supabase.co'
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVybnNkY29xZHd3dXRjemx1dXVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5MDc0MjcsImV4cCI6MjA2NzQ4MzQyN30.KqefkjYBujhWs4BWuOzObQ3KskNssSLQ8Y08IVGvCsY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
